<template>
  <div class="screen-hotkey-group" role="radiogroup">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { onMounted, watchEffect } from 'vue'
import { useScreenStore } from '@/store/ScreenStore'

const { setHotKeys } = useScreenStore()

onMounted(() => {
  setHotKeys()
})

watchEffect(() => {
  setHotKeys()
})
</script>
<style lang="scss" scoped>
.screen-hotkey-group {
  margin-bottom: $spacer-4;
}
</style>
